import * as React from 'react';
import { Box } from '@mui/material';

import { DateTime } from 'luxon';
import { TableContext } from '@particles';
import { TextView } from '@atoms';
import { useSrtTokens } from '@api';
import { Table } from '@organisms';

import { columns, generateRows } from './partials';

interface SrtTokenUsageListProps {
  dates: { start: DateTime; end: DateTime };
  locationId?: string;
  billingAccountId?: string;
}

const SrtTokenUsageList: React.FC<SrtTokenUsageListProps> = ({
  locationId,
  billingAccountId,
  dates
}: SrtTokenUsageListProps) => {
  const {
    state: {
      srtPagination: { page, perPage, orderBy }
    }
  } = React.useContext(TableContext);

  const { data: srtUsage, isFetching: isLoading } = useSrtTokens<Pagination<SrtToken>>({
    from: dates.start.toISO({
        suppressMilliseconds: true,
        includeOffset: false
      }),
    to: dates.end.toISO({
        suppressMilliseconds: true,
        includeOffset: false
      }),
    pageNumber: page,
    pageSize: perPage,
    locationId,
    billingAccountId
  });


  const rowData: TableRow[] = srtUsage?.data ? generateRows(srtUsage.data.data) : [];

  return (
    <Box mt={6}>
      <TextView fontSize={22} fontWeight={600} sx={{ mb: 2 }}>
        Daily usage breakdown
      </TextView>
      <Table
        columns={columns}
        data={rowData}
        isLoading={isLoading}
        name={'srt'}
        pagination={srtUsage?.data}
        persistColumnPrefs
      />
    </Box>
  );
};

export default SrtTokenUsageList;
